var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "research-filter search-input cols" },
        [_c("research-search", { on: { triggerSearch: _vm.searchTerm } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "research-filter research-year dropdown-input cols" },
        [
          _c(
            "button",
            {
              attrs: {
                type: "button",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "true",
              },
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.selectedYear) +
                  "\n                    "
              ),
              _c("img", {
                staticClass: "arrow-down-icon svg",
                attrs: {
                  src: "/app/themes/ucla/resources/assets/images/chevron.svg",
                  width: "16px",
                  height: "16px",
                  alt: "dropdown",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "sr-only" }, [_vm._v("Dropdown")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "dropdown-menu" },
            [
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.resetYear()
                      },
                    },
                  },
                  [_vm._v("All")]
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.years, function (item, index) {
                return _c("research-year", {
                  key: index,
                  attrs: { item: item },
                  on: { chooseYear: _vm.onChooseYear },
                })
              }),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "research-filter dropdown-input cols" }, [
        _c(
          "button",
          {
            attrs: {
              type: "button",
              "data-toggle": "dropdown",
              "aria-haspopup": "true",
              "aria-expanded": "true",
            },
          },
          [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.selectedValue) +
                "\n                    "
            ),
            _c("img", {
              staticClass: "arrow-down-icon svg",
              attrs: {
                src: "/app/themes/ucla/resources/assets/images/chevron.svg",
                width: "16px",
                height: "16px",
                alt: "dropdown",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "sr-only" }, [_vm._v("Dropdown")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "dropdown-menu" },
          [
            _c("li", [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.resetCategory()
                    },
                  },
                },
                [_vm._v("All")]
              ),
            ]),
            _vm._v(" "),
            _vm._l(_vm.categories, function (item, index) {
              return _c("research-category", {
                key: index,
                attrs: { item: item },
                on: { chooseCategory: _vm.onChooseCategory },
              })
            }),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "row loader" }, [
          _c("div", { staticClass: "col-12 text-center" }, [
            _vm._v("\n\t\t\t\tLoading List...\n\t\t\t"),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row accordion-group transition-group" },
      [
        _c(
          "transition-group",
          { attrs: { name: "fade", tag: "div" } },
          _vm._l(_vm.items, function (item, index) {
            return _c("research-accordion", {
              key: index,
              attrs: { item: item },
            })
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.loadingExtra
      ? _c("div", { staticClass: "row loader" }, [
          _c("div", { staticClass: "col-12 text-center" }, [
            _vm._v("\n\t\t\t\tLoading more results...\n\t\t\t"),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.results.length == 0 && !_vm.loading
      ? _c("div", { staticClass: "row" }, [_vm._m(0)])
      : _vm._e(),
    _vm._v(" "),
    !_vm.noMoreItems && !_vm.loading && !_vm.loadingExtra
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 mt-3 text-center" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-primary",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.loadMore.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Load More")]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "text-center" }, [
        _vm._v("\n\t\t\t\t\tNo documents available.\n\t\t\t\t"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/ResearchDirectory.vue